/**
 *  CORE COMPONENTS
 */
import jQuery from 'jquery';
import jQueryUI from 'jquery-ui-dist/jquery-ui.min.js?raw'; // Pauschal is stupid

Object.assign(window, { $: jQuery, jQuery });

eval.call(window, jQueryUI);
